import { isValidEmail } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

export const CloneAgentFormSchema = (t, newAgents) =>
  z
    .object({
      agentName: z.string().optional(),
      agentEmail: z.string().optional(),
      channelId: z.string().optional(),
      cloneConfiguration: z.boolean().optional(),
      cloneAgentInLenderContext: z.boolean().optional(),
      clonedAgentId: z.string().optional(),
      clonePricings: z.boolean().optional(),
      cloneCreateUser: z.boolean().optional(),
      sendPasswordRecovery: z.boolean().optional(),
    })
    .strict()
    .refine(
      (data) => {
        if (newAgents.length === 0 && !data.agentName) {
          return false;
        }
        return true;
      },
      { message: t('REQUIRED_FIELD'), path: ['agentName'] },
    )
    .refine(
      (data) => {
        if (newAgents.length === 0 && !data.agentEmail) {
          return false;
        }
        return true;
      },
      { message: t('REQUIRED_FIELD'), path: ['agentEmail'] },
    )
    .refine(
      (data) => {
        if (newAgents.length === 0 && !data.channelId) {
          return false;
        }
        return true;
      },
      { message: t('REQUIRED_FIELD'), path: ['channelId'] },
    )
    .refine(
      (data) => {
        if (data.agentEmail) {
          return isValidEmail(data.agentEmail);
        }
        return true;
      },
      { message: t('INVALID_EMAIL'), path: ['agentEmail'] },
    )
    .refine(
      (data) => {
        if (newAgents.length > 0 && data.agentEmail && !data.agentName) {
          return false;
        }
        return true;
      },
      { message: t('REQUIRED_FIELD'), path: ['agentName'] },
    )
    .refine(
      (data) => {
        if (newAgents.length > 0 && data.agentName && !data.agentEmail) {
          return false;
        }
        return true;
      },
      { message: t('REQUIRED_FIELD'), path: ['agentEmail'] },
    );

export type CloneAgentFormFields = z.infer<ReturnType<typeof CloneAgentFormSchema>>;
